import { create } from 'zustand';
import type { PublisherDataMode } from '../api/publisherApi';

interface PublisherModeState {
  adminMode: PublisherDataMode;
  setAdminMode: (mode: PublisherDataMode) => void;
  toggleAdminMode: () => void;
  reset: () => void;
}

export const usePublisherModeStore = create<PublisherModeState>((set) => ({
  adminMode: 'real',

  setAdminMode(adminMode) {
    set({ adminMode });
  },

  toggleAdminMode() {
    set((state) => ({ adminMode: state.adminMode === 'mock' ? 'real' : 'mock' }));
  },

  reset() {
    set({ adminMode: 'real' });
  },
}));
